<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formatted"
        :label="label"
        prepend-inner-icon="mdi-calendar"
        readonly
        clearable
        dense
        hide-details
        v-bind="attrs"
        v-on="on"
        @click:clear="$emit('input', null)"
      />
    </template>
    <v-date-picker
      :value="isoDay"
      :locale="$i18n.locale"
      first-day-of-week="1"
      @input="pick"
    />
  </v-menu>
</template>

<script>
import { dateUtil } from "../../api/api";

export default {
  name: "risk-date-field",
  props: {
    value: { default: null },
    label: { type: String, default: "" },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    isoDay() {
      if (!this.value) return null;
      return String(this.value).slice(0, 10);
    },
    formatted() {
      if (!this.isoDay) return "";
      return dateUtil(new Date(this.isoDay), false, "-");
    },
  },
  methods: {
    pick(day) {
      this.menu = false;
      this.$emit("input", day);
    },
  },
};
</script>
